import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { contabilidadService } from '../services/contabilidadService';
import type { BeneficiarioContable, CreateBeneficiarioPayload } from '../types';

export const BENEFICIARIOS_QUERY_KEY = ['contabilidad', 'beneficiarios'] as const;

export function useBeneficiarios() {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery<BeneficiarioContable[]>({
    queryKey: BENEFICIARIOS_QUERY_KEY,
    queryFn: () => contabilidadService.listBeneficiarios(),
    staleTime: 1000 * 60,
  });

  const createMutation = useMutation({
    mutationFn: (payload: CreateBeneficiarioPayload) =>
      contabilidadService.createBeneficiario(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BENEFICIARIOS_QUERY_KEY });
    },
  });

  return {
    beneficiarios: data ?? [],
    isLoading,
    error,
    createBeneficiario: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
